module.exports = __webpack_public_path__ + "img/mobVerticalLine.f7958e75.svg";